"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import Carousel from "./popular/components/Carousel";
import { Separator } from "@/components/ui/separator";

const RecentlyViewed = () => {
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  useEffect(() => {
    const recentlyViewedIds = localStorage.getItem("recentlyViewedProducts");
    const parsedIds = recentlyViewedIds ? JSON.parse(recentlyViewedIds) : [];
    const uniqueIds = Array.from(new Set(parsedIds));
    setRecentlyViewed(uniqueIds);
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center pb-2">
        <h1 className="text-xl font-medium text-custom-black">
          Recently Viewed
        </h1>
        {/* <Link
          href="/"
          className="text-custom-black"
          title="Explore Recent Viewed Products"
        >
          <button className="group relative overflow-hidden rounded-lg bg-white px-4 py-2">
            <div className="absolute inset-0 w-2.5 bg-custom-yellow transition-all duration-300 ease-out group-hover:w-full"></div>
            <span className="relative font-medium group-hover:text-white text-sm">
              See All Viewed
            </span>
          </button>
        </Link> */}
      </div>
      <Separator className="bg-custom-underline-yellow h-0.5"></Separator>
      <Carousel data={recentlyViewed} />
    </div>
  );
};

export default RecentlyViewed;
